import React from 'react';
import { useLanguage } from '../../i18n/useLanguage';
import { StaticPage } from '../StaticPage';
import { TermsGerman } from './terms/TermsGerman';
import { TermsEnglish } from './terms/TermsEnglish';

export const TermsPage: React.FC = () => {
  const { language } = useLanguage();
  return (
    <StaticPage titleKey="static.terms">
      {language === 'de' ? <TermsGerman /> : <TermsEnglish />}
    </StaticPage>
  );
};
